/**
 * Aurora extraction-status widget - Alpine.js component
 *
 * Draggable FAB + status panel for livewire/extraction-status-tray.blade.php.
 * Lives in the app.js bundle (not an inline blade <script>) because the widget
 * is often ADDED to the page by a Livewire morph or a Turbo body swap — both
 * paths skip execution of injected <script> tags, which left x-data pointing
 * at an undefined factory and the widget rendered but dead to clicks.
 */
export default function auroraWidget() {
    return {
        open: false,
        x: null, y: null,
        dragging: false, moved: false, offX: 0, offY: 0, startX: 0, startY: 0,
        flipX: false, flipY: false,
        init() {
            try {
                const saved = JSON.parse(localStorage.getItem('aurora_widget_pos') || 'null');
                if (saved && typeof saved.x === 'number') { this.x = saved.x; this.y = saved.y; }
            } catch (e) {}
            this.$nextTick(() => { this.clamp(); this.computeFlip(); });
        },
        clamp() {
            if (this.x === null) return;
            const el = this.$refs.widget; if (!el) return;
            const w = el.offsetWidth, h = el.offsetHeight;
            this.x = Math.max(8, Math.min(this.x, window.innerWidth - w - 8));
            this.y = Math.max(8, Math.min(this.y, window.innerHeight - h - 8));
        },
        // Flip the panel toward screen-center so it never clips off the edge.
        computeFlip() {
            if (this.x === null) { this.flipX = false; this.flipY = false; return; } // default bottom-left
            const fab = 48;
            this.flipX = (this.x + fab / 2) > window.innerWidth / 2;  // right half -> open left
            this.flipY = this.y < 300;                                // near top -> open downward
        },
        // `moved` guards the FAB @click so finishing a drag doesn't toggle the
        // panel; the next pointerdown resets it, so it eats exactly one click.
        down(e) {
            this.dragging = true; this.moved = false;
            const r = this.$refs.widget.getBoundingClientRect();
            this.offX = e.clientX - r.left; this.offY = e.clientY - r.top;
            this.startX = e.clientX; this.startY = e.clientY;
        },
        move(e) {
            if (!this.dragging) return;
            // Movement threshold so a slightly-wobbly tap still counts as a click, not a drag.
            if (!this.moved && Math.hypot(e.clientX - this.startX, e.clientY - this.startY) < 5) return;
            this.moved = true;
            this.x = e.clientX - this.offX; this.y = e.clientY - this.offY;
            this.computeFlip();
        },
        up() {
            if (!this.dragging) return;
            this.dragging = false; this.clamp(); this.computeFlip();
            if (this.x !== null) localStorage.setItem('aurora_widget_pos', JSON.stringify({ x: this.x, y: this.y }));
        },
        posStyle() {
            return this.x === null ? '' : `left:${this.x}px; top:${this.y}px; right:auto; bottom:auto;`;
        },
    };
}
